import { createSlice } from '@reduxjs/toolkit'

const stateSlice = createSlice({
    name: 'cityTrash/state',
    initialState: {
        deleteConfirmation: false,
        recoverConfirmation: false,
        selectedCity: [],
        sortedColumn: () => {},
    },
    reducers: {
        toggleDeleteConfirmation: (state, action) => {
            state.deleteConfirmation = action.payload
        },
        toggleRecoverConfirmation: (state, action) => {
            state.recoverConfirmation = action.payload
        },
        setSortedColumn: (state, action) => {
            state.sortedColumn = action.payload
        },
        setSelectedCity: (state, action) => {
            state.selectedCity = action.payload
        },
    },
})

export const { 
    toggleDeleteConfirmation,
    toggleRecoverConfirmation,
    setSortedColumn,
    setSelectedCity
} = stateSlice.actions

export default stateSlice.reducer
